import React, { useState, useEffect } from 'react';
import { getPendingQuotes } from '../api/client';
import QuoteList from '../components/QuoteList';
import QuoteDetail from '../components/QuoteDetail';

export default function OwnerView() {
    const [quotes, setQuotes] = useState([]);
    const [selectedQuote, setSelectedQuote] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadQuotes();

        // Poll for new quotes every 30 seconds
        const interval = setInterval(loadQuotes, 30000);
        return () => clearInterval(interval);
    }, []);

    const loadQuotes = async () => {
        try {
            const result = await getPendingQuotes();
            setQuotes(result.quotes || []);
        } catch (error) {
            console.error('Failed to load quotes:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSelectQuote = (quote) => {
        setSelectedQuote(quote);
    };

    const handleCloseDetail = () => {
        setSelectedQuote(null);
        loadQuotes();
    };

    return (
        <div className="owner-view">
            <h1>Pending Quotes</h1>

            {loading ? (
                <p>Loading quotes...</p>
            ) : (
                <>
                    <div className="stats">
                        <span>{quotes.length} pending quotes</span>
                    </div>

                    <QuoteList
                        quotes={quotes}
                        onSelectQuote={handleSelectQuote}
                    />
                </>
            )}

            {selectedQuote && (
                <QuoteDetail
                    quote={selectedQuote}
                    onClose={handleCloseDetail}
                />
            )}
        </div>
    );
}
